import React, { FC } from 'react';
import { LayoutProps, useTranslate } from '@refinedev/core';
import { Grid, Layout as AntdLayout } from 'antd';
import Container from '../../container';
import { getFullYear } from '../../../../utils/date';
import styles from '../Layout.module.scss';
import { Footer } from '../../footer';
import AccessibilityToolbar from '../../../AccessibilityToolbar';

export const Layout: FC<LayoutProps> = ({
    children,
    Header,
    OffLayoutArea,
}) => {
    const t = useTranslate();
    const breakpoint = Grid.useBreakpoint();

    return (
        <AntdLayout className={styles.pageWrapper}>
            <AccessibilityToolbar />
            <AntdLayout className={styles.innerPageWrapper}>
                {Header && <Header />}
                <AntdLayout.Content>
                    <div
                        style={{
                            padding: breakpoint.sm ? 24 : 12,
                            minHeight: 360,
                        }}
                    >
                        <Container
                            max={1580}
                            padX={35}
                            className={styles.contentContainer}
                        >
                            {children}
                        </Container>
                    </div>
                    {OffLayoutArea && <OffLayoutArea />}
                </AntdLayout.Content>

                <Footer>
                    <Container max={1580} padX={35}>
                        {getFullYear()} {t('all_rights_reserved')}
                    </Container>
                </Footer>
            </AntdLayout>
        </AntdLayout>
    );
};
